module.exports = __webpack_public_path__ + "media/images/service-overview-bg-9eb5af8766c2df50f9b95e8d20021370.png";